import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useStore } from '../../app/stores/store';
import { Button, Dropdown, Segment } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { WorkFlowTask } from '../../app/models/template';
import agent from '../../app/api/agent';
import { ThreeDotLoader } from '../../app/layout/LoadingComponent';
import { updateHistoryMain } from '../../app/models/history';
import sendRespectiveEmail from '../../app/models/EmailNew';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { defaultRow, shallowCompare } from './smarttrackerType';

interface Props {
  rowDataId: string;
  commonSearch: any;
  getNewDetails: any;
  pageNumData: any;
  trackerRowData: any;
  sortedListItems: any;
  listTaskItems: WorkFlowTask[];
  setListTaskItems: Dispatch<SetStateAction<WorkFlowTask[]>>;
  //
  currentTitle_Code?: {
    value: string;
    list: {
      key: string;
      value: string;
      text: string;
    }[];
  };
  setCurrentTitle_Code?: any;
  currentPl_id?: {
    value: string;
    list: {
      key: string;
      value: string;
      text: string;
    }[];
  };
  setCurrentPl_id?: any;
  currentDisplayName?: {
    value: string;
    list: {
      key: string;
      value: string;
      text: string;
    }[];
  };
  setCurrentDisplayName?: any;
  hierarchy?: {
    value: string;
    list: {
      key: string;
      value: string;
      text: string;
    }[];
  };
  setHierarchy?: any;
  clickTaskHandler?:any
  setPageNumber?:any
  // completeAPIHandler?: any;
}


function SmartTrackerButtonconfig({
  trackerRowData,
  setCurrentTitle_Code,
  currentTitle_Code,
  currentPl_id,
  setCurrentPl_id,
  currentDisplayName,
  setCurrentDisplayName,
  clickTaskHandler,
  getNewDetails,
  setPageNumber,
}: 
Props) {
  // route
  const {
    TrackingReportStore,
    mediaAssetStore,
    userStore,
    activityStore,
    metaDataStore,
    RestorationStore,
    commonStore,
    dashboardStore:{dashboard,setReportsPageNum},
    reportStore,
    viewStore
  } = useStore();
  const ids = useParams();
  const { templateId } = ids as any;
  const { selectedActivity: activity } = activityStore;
  let {
    showButton,
    statusButtonShow,
    workflowCurrentTaskId,
    workflowCurrentSubtaskDetails,
    bindComponent,
  } = TrackingReportStore;
  const [selectedSubTask, setSelectedSubtask] = useState<any>();

  useEffect(() => {
    setSelectedSubtask(workflowCurrentSubtaskDetails[0]);
  }, [workflowCurrentSubtaskDetails]);



  const HistoryPost = async (data: string) => {
    mediaAssetStore.mediaAsset.openStart = true;
    if (activity !== undefined) {
      const payload = {
        taskId: workflowCurrentTaskId,
        taskName: trackerRowData['current_task'],
        subTaskId: selectedSubTask.subTaskId,
        subTaskName: selectedSubTask.subTaskName,
        status: data,
        date: new Date(),
      };
      await updateHistoryMain(
        payload,
        true,
        false,
        true,
      );
      let mailBody = '';
      if (!data.includes('resolved')) {
        mailBody = `Dear ${userStore.user?.displayName},<br/>\u00A0 This notification is to inform you that you have ${data}${activity?.title}. <br/> <br/> Regards, <br/> info@honeycombmanager.com`;
      } else {
        mailBody = `Dear ${userStore.user?.displayName},<br/>\u00A0 This notification is to inform you that you have resolved "${selectedSubTask.subTaskName}" to "${''}" for ${activity?.title}. <br/> <br/> Regards, <br/> info@honeycombmanager.com`;
      }
      sendRespectiveEmail(
        'edited',
        activity.title,
        'Edited WorkFlow in Asset',
        '',
        '',
        '',
        mailBody,
      );
    }
  };


  const updateComponent = async (statusNumber:string)=>{
    const statusPayload = {
      itemId: activity?.id,
      currentTask: activity?.current_task || '', 
      currentSubtask: selectedSubTask.subTaskName,
      actionerName: userStore?.user?.displayName || '',
      resolveSubtaskId: '',
      status: parseInt(statusNumber),
  };
  
    if(!commonStore.RestorationCustomer){
      await agent.viewPage.workFlowProcessChanges(statusPayload);
      await getNewDetails(dashboard.setReportsPageNum);
      return;
    }
      if(statusNumber === '5' && commonStore.RestorationCustomer){
        const hasEmptyStringOrZero = (array: any[]) => array.some((obj: any) => Object.entries(obj).some(([key, val]) => key !== "sDefect_SF" && key !== "qcRemarks" && (val === "" || val === 0)));
        if(hasEmptyStringOrZero(TrackingReportStore.bindComponent.defects)){
          toast.warn('Please fill all inputs.');
          return;
        } 
      }
      else{
        const Defects = TrackingReportStore.bindComponent.defects
        const condition =  Defects.length === 1 ? shallowCompare(Defects[0],defaultRow[0]) : true
        if (Defects.length > 1 || !condition) {
          toast.warn('Please remove all defects. Only reject time entry.');
          return;
      }
      
      }
    TrackingReportStore.isSmartTrackerButtonLoading = true;
    TrackingReportStore.bindComponent.model = false;
    TrackingReportStore.bindComponent.loader = true;

    const statusMessages:any = {
      '1': `started working on ${selectedSubTask.subTaskName} for `,
      '2': `completed ${selectedSubTask.subTaskName} for `,
      '3': `holded ${selectedSubTask.subTaskName} for `,
      '4': `resumed working on ${selectedSubTask.subTaskName} for `,
      'default': `rejected SubTask "${selectedSubTask.subTaskName}" due to "${''}" for `
  };
  
  const message = statusMessages[statusNumber] || statusMessages['default'];
  HistoryPost(message);
  
    const payload = {
      itemID: activity?.id,
      actionName: statusNumber,
      subTaskName: trackerRowData['current_subtask']
  };

  

  const restorationPayload = {
      itemLevelId: activity?.id,
      taskId: workflowCurrentTaskId,
      taskName: trackerRowData['current_task'] || '',
      subTaskId: selectedSubTask?.subTaskId,
      subTaskName: selectedSubTask?.subTaskName,
      currentUser: userStore?.user?.displayName,
      actionName: statusNumber.toString() || '',
      titleStatus: bindComponent?.titleStatus || ''
  };

  statusButtonShow('');
  reportStore.loadMetadataReportComponent = true;
  try {
    await Promise.all([
      agent.viewPage.workFlowProcessChanges(statusPayload),
      RestorationStore.restoratioHoursUpdate(restorationPayload),
      agent.SmartTracker.UpdateRestorationTaskStatusInformationGet(payload),
      agent.SmartTracker.UpdateinputOutPath(activity?.id, bindComponent.inputPath, bindComponent.outputPath,bindComponent.frrInformation)
    ]);
  } catch (error) {
    console.log(error)
  }
  
if(statusNumber === '5'){
  if(bindComponent.defects.length > 0){
    const payload = bindComponent.defects.map(defect => ({
      ...defect,
      itemid: activity?.id,
      operator_empid: selectedSubTask?.subTaskName === "Client Quality Check" 
      ? TrackingReportStore.bindComponent.PreviousEmpId
       : bindComponent.empId,
      
    }));
    await agent.SmartTracker.createRejectHistory(payload)
    commonStore.updateHistoryAlonePOST(
      `${userStore.user?.displayName} added record ${JSON.stringify(
        payload,
            // eslint-disable-next-line
      )} to Dynamic table "${`\"Defects\"`}" for ${activityStore
        .selectedActivity?.title}`,
      activityStore.selectedActivity?.id,
      undefined,
      false,
    );    
  }
}
  if(statusNumber === '1'|| statusNumber === '2' || statusNumber === '3' || statusNumber === '4'|| statusNumber === '5'){
  if(currentPl_id?.value === '' && currentTitle_Code?.value === '' && currentDisplayName?.value === ''){
    let result = await agent.ProdPlanning.listProductionPlanningTemplate({
      templateId,
    });
     clickTaskHandler(result.data[0].task || '', result.data,true,dashboard.inventoryCount2 !== 1 );
  }
  else{
    TrackingReportStore.productionPlanning.dropdownChanges = true;  
    setReportsPageNum(1);
    setPageNumber(1);
  }
  }else{
      getNewDetails(dashboard.setReportsPageNum);
  }
  reportStore.loadMetadataReportComponent = false;
    TrackingReportStore.isSmartTrackerButtonLoading = false;  
    if(selectedSubTask.subTaskName === "Client Quality Check" && statusNumber === "5") { 
      try {
        await agent.Restoration.ClientqcIsActiveUpdate(selectedSubTask.subTaskId);
            const subTasks = viewStore.activeOrder.tasks?.[0].subTasks ?? [];
            const isExactlyQcAndFqaOnly = 
          subTasks.some(x => x.subTaskName === "Quality Check" && x.isActive) &&
          subTasks.some(x => x.subTaskName === "Final Quality Analysis" && x.isActive);

      if (isExactlyQcAndFqaOnly) {
          const fqaSubTask = subTasks.find(x => x.subTaskName === "Final Quality Analysis");
          if (fqaSubTask) {
              await agent.Restoration.ClientqcIsActiveUpdate(fqaSubTask.subTaskId);
              toast.success(`Successfully updated FQA status for subTaskId: ${fqaSubTask.subTaskId}`);
          }
      }
      } catch (error) {
        toast.error(`Failed to update Client QC status: ${error}`);
      }
     }
    
  }
  const buttonstartproject = async () => {
    updateComponent('1');
  };

  const openCompleted = () => {
    updateComponent('2');
  };

  const openHold = () => {
    updateComponent('3');
  };

  const openResume = async () => {
    updateComponent('4');
  };

  const openReject = () => {
    if (userStore.user?.roleName === 'Operator') {
      toast.error(`Access Denied: As an Operator, you are not authorized to reject entries.`);
      return;
    }
    updateComponent('5');
  };

  return (
    <div>
      <Segment style={{padding: '0em 0.5em'}}>
                <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          > 
          <div>
            {userStore.user?.customerName === 'Restoration' && (
              <>
                <Dropdown
                  style={{ margin: '5px' }}
                  downward
                  clearable
                  options={currentTitle_Code?.list || []}
                  selection
                  search
                  placeholder="Title Code"
                  onChange={(e: any, data1: any) => {
                    metaDataStore.dropDowndata('');
                    TrackingReportStore.statusButtonShow('');
                    setCurrentTitle_Code({
                      ...currentTitle_Code,
                      value: data1.value,
                    });
                  }}
                  value={currentTitle_Code?.value || ''}
                />
                {userStore.user?.roleName !== 'Operator' && (
                  <>
                    <Dropdown
                      style={{ margin: '5px' }}
                      downward
                      clearable
                      search
                      options={currentPl_id?.list || []}
                      selection
                      placeholder="PL Id"
                      onChange={(_event: any, data: any) => {
                        metaDataStore.dropDowndata('');
                        TrackingReportStore.statusButtonShow('');
                        setCurrentPl_id({
                          ...currentPl_id,
                          value: data.value,
                        });
                      }}
                      value={currentPl_id?.value || ''}
                    />
                    <Dropdown
                      style={{ margin: '5px' }}
                      downward
                      clearable
                      options={currentDisplayName?.list || []}
                      selection
                      search
                      placeholder="Current DisplayName"
                      onChange={(_event: any, data: any) => {
                        metaDataStore.dropDowndata('');
                        TrackingReportStore.statusButtonShow('');
                        setCurrentDisplayName({
                          ...currentDisplayName,
                          value: data.value,
                        });
                      }}
                      value={currentDisplayName?.value}
                    />
                  </>
                )}
              </>
            )}
          </div>
          <div>
            {TrackingReportStore.isSmartTrackerButtonLoading ? (
              <div
                style={{ position: 'relative', width: '40px', height: '48px' }}
              >
                <ThreeDotLoader />
              </div>
            ) : (
              <>
                {showButton.start && (
                  <Button onClick={() => buttonstartproject()} color="blue">
                    Start
                  </Button>
                )}
                {showButton.complete && (
                  <Button.Group floated="right">
                    <Button color="blue" onClick={() => openCompleted()}>
                      {' '}
                      Complete{' '}
                    </Button>
                    <Button.Or />
                    <Button
                      color="yellow"
                      //openHold
                      onClick={() => openHold()}
                    >
                      {' '}
                      Hold
                    </Button>
                    <Button.Or />
                    <Button color="red" onClick={() => 
                    selectedSubTask.subtask === 'Full Restoration' ? 
                    toast.info("To reject, Full Restoration is not permitted.")
                     :openReject()}>
                      Reject
                    </Button>
                  </Button.Group>
                )}

                {showButton.Resume === true && (
                  <Button onClick={() => openResume()}> Resume </Button>
                )}
              </>
            )}
          </div>
        </div>
      </Segment>
      {/*   {isResolveModalOpened && (
        <MediaAssetResolveModal
          selectedSubTaskId={selectedSubTask.subTaskId}
          smartTracker
          closeHandler={() => {
            setTimeout(() => {
              getNewDetails(false);
            }, 500);
            // setCurrStatus(5);
            setIsResolveModalOpened(false);
          }}
          submitHandler={(resolveData?: {
            resolveId: string;  
            resolveName: string;
          }) => {
            updateComponent('7');
            HistoryPost(`rejected SubTask "${selectedSubTask.subTaskName}" due to "${''}" for `)
            // ReportsData('Resolve', 7, resolveData);
            setIsResolveModalOpened(false);
          }}
        />
      )}
    
       {showWorkflowModel && (
        <TaskFormModal
          taskname={trackerRowData['current_task']}
          showTasksModal={showTasksModal}
          closeTaskFormModal={closeTaskFormModal}
          selectedSubTask={workflowCurrentSubtaskDetails[0]}
          eleModalTitle={eleModalTitle}
          subTaskIdNo={workflowCurrentSubtaskId}
          taskData={sortedListItems}
          taskId={workflowCurrentTaskId}
          currSubTaskData={workflowCurrentSubtaskDetails[0]}
          hideSubtask={hideSubtask}
          actionerNameHandler={actionerNameHandler}
          workflowHistoryHandler={workflowHistoryHandler}
          reportWorflowUpdate={reportWorflowUpdate}
          // name={'SmartTracker'}
          SmartTrackerReports={true}
          // completeAPIHandler={completeAPIHandler}
          setSmartTrackButtonLabel={setSmartTrackButtonLabel}
          smartTrackButtonLabel={smartTrackButtonLabel}
        />
      )} */}
    </div>
  );
}
export default observer(SmartTrackerButtonconfig);
